export default "__VITE_ASSET__DycfJMCI__"